const SIZES = {
  sm: "h-12",
  md: "h-16 sm:h-[72px]",
  lg: "h-[88px] sm:h-[100px]",
  xl: "h-[104px] sm:h-[120px]",
};

export function Logo({ variant = "md", className = "" }) {
  return (
    <img
      src="/suffle-logo-new.png?v=2"
      alt="Suffle Online"
      className={`logo-anim w-auto shrink-0 self-start object-contain ${SIZES[variant] || SIZES.md} ${className}`}
      data-testid="suffle-logo"
    />
  );
}

export function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src="/suffle-logo-new.png?v=2"
      alt="Suffle"
      style={{ height: size, width: size }}
      className={`shrink-0 object-contain ${className}`}
      data-testid="suffle-logo-mark"
    />
  );
}
